const getters = {
  featureFlagsMap: state => {
    return { ...(state.flags || {}) }
  },
  customContentCoursesEnabled: (state) => {
    return !!state.customContentCoursesEnabled
  },
  customContentVideosEnabled: (state) => {
    return !!state.customContentVideosEnabled
  },
}

export default getters
